import script from "./InputRange.vue?vue&type=script&setup=true&lang=js"
export * from "./InputRange.vue?vue&type=script&setup=true&lang=js"

import "./InputRange.vue?vue&type=style&index=0&id=4d703752&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d703752"]])

export default __exports__